import React from 'react';

import { SearchVacancies } from '../../../components';

import './style.scss';

const ParagraphVacanciesOverview = () => {

  return (
    <div className="Paragraph ParagraphVacanciesOverview">
      <SearchVacancies>
        <div className="row">
          <div className="col-12">
            <SearchVacancies.Filters />
          </div>

          <div className="col-12">
            <SearchVacancies.SearchBar />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-3">
            <SearchVacancies.Facets />
          </div>

          <div className="col-12 offset-lg-1 col-lg-8">
            <SearchVacancies.Results />
          </div>
        </div>
      </SearchVacancies>
    </div>
  );
};

export default ParagraphVacanciesOverview;
